module.exports = __webpack_public_path__ + "static/media/banner6.3783937f.jpg";